/* eslint-disable */
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import exclamation from '../../assets/images/exclamation.png';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import RulerPicker from 'src/onboarding/components/ui/ruler-picker/RulerPicker';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

function Page() {
  const weight = useStore((state) => state.weight);
  const idealWeight = useStore((state) => state.idealWeight);
  const setIdealWeight = useStore((state) => state.setIdealWeight);
  const { bmi, setBmi } = useStore((state) => state);
  const loosGoal = useStore((state) => state.loosGoal);

  const { onNext, onPrev, currentIndex } = useNav();
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (weight.type === 'lbs') {
      setIdealWeight({ ...idealWeight, type: 'lbs' });
    } else {
      setIdealWeight({ ...idealWeight, type: 'kg' });
    }
  }, []);

  useEffect(() => {
    if (idealWeight?.value?.length >= 2) {
      calculateNotification();
    } else {
      setNotification(null);
    }
  }, [idealWeight.value]);

  const calculateNotification = () => {
    const weightInKg = weight.type === 'lbs' ? +weight.lbs * 0.453592 : +weight.kg;
    const idealWeightInKg =
      idealWeight.type === 'lbs' ? +idealWeight.value * 0.453592 : +idealWeight.value;

    const weightLossPercentage = ((weightInKg - idealWeightInKg) / weightInKg) * 100;

    if (bmi >= 25.0 && weightLossPercentage >= 20) {
      setNotification({
        title: t('onboarding.idealWeight.notifications.1.title').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
        message: t('onboarding.idealWeight.notifications.1.message').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
      });
    } else if (bmi > 18.5 && weightLossPercentage >= 10 && weightLossPercentage < 20) {
      setNotification({
        title: t('onboarding.idealWeight.notifications.2.title').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
        message: t('onboarding.idealWeight.notifications.2.message').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
      });
    } else if (bmi > 18.5 && weightLossPercentage >= 5 && weightLossPercentage < 10) {
      setNotification({
        title: t('onboarding.idealWeight.notifications.3.title').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
        message: t('onboarding.idealWeight.notifications.3.message').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
      });
    } else if (bmi < 18.5 && weightLossPercentage >= 1) {
      setNotification({
        title: t('onboarding.idealWeight.notifications.4.title').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
        message: t('onboarding.idealWeight.notifications.4.message').replace(
          '{VALUE}',
          weightLossPercentage.toFixed(1)
        ),
      });
    } else {
      setNotification(null);
    }
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.idealWeight.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {' '}
          {loosGoal === 'Maintain weight and get fit'
            ? t('onboarding.idealWeight.subTitleWithoutWeightLoss')
            : t('onboarding.idealWeight.subTitle')}
        </Text>
      </div>

      <div className={'controls controls_new'}>
        <div className={'tabs'}>
          <span
            className={cn({ active: idealWeight.type === 'kg' })}
            onClick={() => {
              setIdealWeight({ ...idealWeight, type: 'kg', value: '' });
            }}
          >
            {' '}
            {t('onboarding.idealWeight.kg')}
          </span>
          <span
            className={cn({ active: idealWeight.type === 'lbs' })}
            onClick={() => {
              setIdealWeight({ ...idealWeight, type: 'lbs', value: '' });
            }}
          >
            {' '}
            {t('onboarding.idealWeight.lbs')}
          </span>
        </div>
        {idealWeight.type === 'kg' && (
          <RulerPicker
            min={30}
            max={200}
            step={1}
            onChange={(newValue) => setIdealWeight({ type: 'kg', value: String(newValue) })}
            initialValue={Number(idealWeight.value) || weight.kg}
            unit='kg'
            stepWidth={15}
            divisions={5}
          />
        )}

        {idealWeight.type === 'lbs' && (
          <RulerPicker
            min={67}
            max={447}
            step={1}
            onChange={(newValue) =>
              setIdealWeight({ type: 'lbs', value: String(Math.round(newValue)) })
            }
            initialValue={Number(idealWeight.value) || weight.lbs}
            unit='lbs'
            stepWidth={7}
            divisions={10}
          />
        )}
      </div>

      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.idealWeight.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'ideal-weight',
              answer:
                idealWeight.type === 'kg'
                  ? idealWeight.value
                  : Math.round(+idealWeight.value * 0.453592),
            });
            onNext();
          }}
        />
      </div>

      {notification && (
        <div className={`notification ${notification.type}`}>
          {
            <div className={'title-container'}>
              {notification.type !== 'normal' && (
                <img className={'exclamation'} src={exclamation} />
              )}
              <Text size='s' semibold style={{ textAlign: 'left' }}>
                {notification.title}
              </Text>
            </div>
          }
          <Caption className={'notification-description'}>{notification.message}</Caption>
        </div>
      )}
    </div>
  );
}

export default Page;
